<template>
  <data-section
    theme="green"
    title="國泰人壽團險"
    :datas="datas"
    :_fields="
      [
        { name: '保單號碼', key: 'policynumber', width: 195,
          sortable: true,
          orderByMultiKey: ['policynumber'],
          orderByMultiType: ['asc'] },
        {
          name: '要保人',
          key: 'comp_name',
          width: 349,
          sortable: true,
          orderByMultiKey: ['comp_name'],
          orderByMultiType: ['asc']
        },
        {
          name: '被保人',
          key: 'insd_name',
          width: 94,
          sortable: true,
          orderByMultiKey: ['insd_name'],
          orderByMultiType: ['asc'],
        },
        {
          name: '投保身分',
          key: 'relation',
          width: 94,
          sortable: true,
          orderByMultiKey: ['relation'],
          orderByMultiType: ['asc'],
        },
        {
          name: '保險計畫/等級',
          key: 'class',
          width: 137,
        },
        {
          name: '有效期間',
          key: 'end_date',
          width: 110,
          sortable: true,
          orderByMultiKey: ['end_date'],
          orderByMultiType: ['asc'],
        }
      ].concat(_fields)
    "
    @toggle="
      (isShow) => $router.assignQuery({ CathayGroupInsuranceShow: isShow })
    "
    :initShow="$route.query['CathayGroupInsuranceShow'] !== 'false'"
  >
    <template scope="props"  v-if="refresh">
      <data-table
        v-bind="Object.assign({}, props, {
              datas: proccessDatas(props)
            })"
        @changeSort="
          (sort) =>
            $router.assignQuery({
              [`CathayGroupInsuranceSort`]: JSON.stringify(sort)
            })
        "
        :initSort="
          $route.query[`CathayGroupInsuranceSort`]
            ? JSON.parse($route.query[`CathayGroupInsuranceSort`])
            : null
        "
      >
        <template slot="comp_name" scope="item">
          <div>
            <div>
              {{ item.data.comp_name}}
            </div>
          </div>
        </template>
        <template slot="insd_name" scope="item">
          <div>
            <div>
              {{ item.data.insd_name | truncate }}
            </div>
          </div>
        </template>
        <template slot="relation" scope="item">
          <div>
            <div>
              {{ translate.relation[item.data.relation]  }}
            </div>
          </div>
        </template>
        <template slot="end_date" scope="item">
          <div
            class="pre-formatted"
            v-html="
              buildStartEndString(
                getROCDate(item.data.c401_rdstdt),
                getROCDate(item.data.end_date)
              )
            "
          ></div>
        </template>
      </data-table>
    </template>
  </data-section>
</template>

<script>
import InsuranceMixins from "./Insurance";

export default {
  mixins: [InsuranceMixins],
  methods: {
    proccessDatas(props) {
      return _.uniqBy(props.datas, (el) => [el.policynumber, el.idno].join());
    },
  }
};
</script>
